export const OVERAGES_ENABLED =
  'Your account is automatically upgraded to the next level of send credits to make sure there are no ' +
  'interruptions to your messaging service.';
